module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/heading-mv-1f3e93c86502473980cee6be0d6cd9c6.png";